// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'

export class ModifyGroup {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyGroup {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyGroup(bb: flatbuffers.ByteBuffer, obj?: ModifyGroup): ModifyGroup {
    return (obj || new ModifyGroup()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyGroup(bb: flatbuffers.ByteBuffer, obj?: ModifyGroup): ModifyGroup {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyGroup()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  group(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  members(index: number, obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Id()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  membersLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startModifyGroup(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addGroup(builder: flatbuffers.Builder, groupOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, groupOffset, 0)
  }

  static addMembers(builder: flatbuffers.Builder, membersOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, membersOffset, 0)
  }

  static startMembersVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static endModifyGroup(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // group
    builder.requiredField(offset, 6) // members
    return offset
  }

  static createModifyGroup(
    builder: flatbuffers.Builder,
    groupOffset: flatbuffers.Offset,
    membersOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    ModifyGroup.startModifyGroup(builder)
    ModifyGroup.addGroup(builder, groupOffset)
    ModifyGroup.addMembers(builder, membersOffset)
    return ModifyGroup.endModifyGroup(builder)
  }
}
